import React from 'react'

export const SubPageContainer = (props) => {
    return <div className={`subPageOuter scroll-box ${props.loginModalOpen ? 'blured' : ''}`}>
        
        {props.installButton}
        
        <div className='subPageInner'>
            {props.children}
        </div>
    </div>
}